import { render, staticRenderFns } from "./Storagepoint.vue?vue&type=template&id=0fba2fbc&scoped=true&"
import script from "./Storagepoint.vue?vue&type=script&lang=js&"
export * from "./Storagepoint.vue?vue&type=script&lang=js&"
import style0 from "./Storagepoint.vue?vue&type=style&index=0&id=0fba2fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fba2fbc",
  null
  
)

export default component.exports